// contactService.js

import API_BASE_URL from '../../../../../Constants';

// Function to add a new contact
export const addContact = async (contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contactData),
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to add contact');
  }

  return response.json(); // Return the response data if needed
};

// Function to edit an existing contact
export const editContact = async (contactID, contactData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/${contactID}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(contactData),
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to edit contact');
  }

  return response.json(); // Return the response data if needed
};

// Function to delete a contact
export const deleteContact = async (contactID) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/${contactID}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to delete contact');
  }

  return; // Return nothing if successful
};

// Function to get a contact by ID
export const getContactById = async (contactID) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/contacts/${contactID}`, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to get contact');
  }

  return response.json();
};
